import millify from 'millify'
export interface ICurrencyFormatOption {
    fraction: boolean
    isAccounting?: boolean
    signDisplay?: boolean
}
function currencyFormat(
    value: number | string,
    currencyLanguage: string,
    currencyCode: string,
    options: ICurrencyFormatOption = {
        fraction: true,
        isAccounting: false,
    },
) {
    if (typeof value === 'string') value = parseFloat(value)
    return new Intl.NumberFormat(
        currencyCode === 'THB' ? 'he-HE' : currencyLanguage,
        {
            minimumFractionDigits: options.fraction ? 2 : undefined,
            maximumFractionDigits: options.fraction ? 2 : undefined,
            currencySign: options?.isAccounting ? 'accounting' : 'standard',
            currency: currencyCode,
            style: 'currency',
            currencyDisplay: 'narrowSymbol',
            signDisplay: options.signDisplay
                ? 'exceptZero'
                : value === 0
                ? 'never'
                : 'auto',
        },
    ).format(value ?? 0)
}
export default currencyFormat

export function currencyMillifyFormat(
    value: number | string,
    currencyLanguage: string,
    currencyCode: string,
    { fraction = true, isAccounting = false }: ICurrencyFormatOption,
) {
    if (typeof value === 'string') value = parseFloat(value)
    var formatResult = currencyFormat(value, currencyLanguage, currencyCode, {
        fraction,
        isAccounting,
    })
    var numberPattern = /[\d,.]+/g

    return `${formatResult.replace(
        numberPattern,
        millify(value, {
            precision: 2,
        }),
    )}`
}
